import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  helperText: {
    marginBottom: theme.spacing(2),
  },
  regionBlock: {
    marginBottom: theme.spacing(2),
  },
  regionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  scopeGrid: {
    marginTop: theme.spacing(1),
  },
  scopeBox: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6,
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
  },
  scopeBoxMuted: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 6,
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
    opacity: 0.72,
  },
  divider: {
    margin: `${theme.spacing(2)}px 0`,
  },
}));
